export default __webpack_public_path__ + "static/runolfsson-3c253e605104abbf9578017cc20d2994.jpg";